import type { ReactNode } from 'react';

import styles from './EmptyState.module.css';

export type EmptyStateProps = {
  readonly icon: ReactNode;
  readonly title: string;
  readonly description?: string;
  readonly action?: ReactNode;
  readonly compact?: boolean;
};

/** Обязателен на всех списках (docs/06 §5.4): иконка, фраза, действие. */
export function EmptyState({ icon, title, description, action, compact = false }: EmptyStateProps) {
  return (
    <div className={compact ? `${styles['empty']} ${styles['compact']}` : styles['empty']}>
      <span aria-hidden className={styles['icon']}>
        {icon}
      </span>
      <p className={styles['title']}>{title}</p>
      {description ? <p className={styles['description']}>{description}</p> : null}
      {action ? <div className={styles['action']}>{action}</div> : null}
    </div>
  );
}
